module.exports = __webpack_public_path__ + "img/gf_qrcode.9643993e.jpg";